<div #pannableAndZoomableContainer [appSvgLoader]="svg" class="svg-pattern-visualisation full-width"></div>
<button mat-icon-button class="mat-icon-action-button-lg-with-border disable-focus actions-button reset-button" (click)="resetPanAndZoom()">
  <mat-icon svgIcon="reset"></mat-icon>
</button>
